import { ICreatePickupDTO, IPickupLocale } from '@/models/regions.model';
import { PickingFormFields, TCreatePickingFormValues } from '../helpers/types';
import { normalizePhone } from '@/utils';
import { DeepPartial } from '@reduxjs/toolkit';
import { SupportedLocales } from '@/models/localization.model';

class BasePickupDTO implements ICreatePickupDTO {
  external_id: string;
  is_active: string;
  is_default: string;
  latitude?: number;
  locale: DeepPartial<IPickupLocale>;
  longitude?: number;
  phone?: string;
  region_id: string;
  settlement_id: string;
  address: string;
  google_store_code: string | null;

  constructor(values: TCreatePickingFormValues) {
    this.address = values[PickingFormFields.ADDRESS]?.locale?.[SupportedLocales.UK]?.name;
    this.external_id = values[PickingFormFields.ADDRESS]?.place_id;
    this.settlement_id = values[PickingFormFields.SETTLEMENT];
    this.region_id = values[PickingFormFields.REGION];
    this.phone = normalizePhone(values[PickingFormFields.PHONE]) || undefined;
    this.is_active = values[PickingFormFields.IS_ACTIVE] ? '1' : '0';
    this.is_default = values[PickingFormFields.IS_DEFAULT] ? '1' : '0';
    this.latitude = values[PickingFormFields.ADDRESS]?.latitude;
    this.longitude = values[PickingFormFields.ADDRESS]?.longitude;
    this.google_store_code = values[PickingFormFields.GOOGLE_STORE_CODE]?.trim() || null;
    this.locale = {
      [SupportedLocales.RU]: {
        address: values[PickingFormFields.ADDRESS]?.locale?.[SupportedLocales.RU]?.name,
        working_hours: values[PickingFormFields.WORKING_HOURS]?.ru?.[PickingFormFields.WORKING_HOURS],
        name: values[PickingFormFields.ADDRESS]?.locale?.[SupportedLocales.RU]?.name,
      },
      [SupportedLocales.UK]: {
        address: values[PickingFormFields.ADDRESS]?.locale?.[SupportedLocales.UK]?.name,
        working_hours: values[PickingFormFields.WORKING_HOURS]?.uk?.[PickingFormFields.WORKING_HOURS],
        name: values[PickingFormFields.ADDRESS]?.locale?.[SupportedLocales.UK]?.name,
      },
    };
  }
}

export default BasePickupDTO;
